import type { XhData } from '@api/types';

export async function timeoutRequest<T>(request: Promise<T>, timeout: number): Promise<T> {
    const timeoutFn: Promise<never> = new Promise((_resolve, reject) => {
        setTimeout(() => {
            const error = new Error('Too slow request');
            error.name = 'Timeout';
            reject(error);
        }, timeout);
    });
    return Promise.race([request, timeoutFn]);
}

export function abortSignalTimeout(milliseconds: number) {
    if (!AbortSignal.timeout) {
        const  timeout = (ms: number) => {
            const controller = new AbortController();
            setTimeout(() => controller.abort(), ms);
            return controller.signal;
        };
        return timeout(milliseconds);
    } else {
        return AbortSignal.timeout(milliseconds);
    }
}

export function getXhData(): XhData | undefined {
    const searchParams = new URLSearchParams(window.location.search);

    const xhExps = searchParams.get('xhExp') || undefined;
    const xhStatsUid = searchParams.get('xhStatsUid') || undefined;
    const xhUserId = searchParams.get('xhUserId') || undefined;

    if (!xhExps && !xhStatsUid && !xhUserId) {
        return undefined;
    }

    return {
        stats_uid: xhStatsUid,
        user_id: xhUserId,
        experiments: xhExps,
    };
}
